import * as React from 'react';

export abstract class Container<P, S> extends React.Component<P, S> {
  abstract state: S
}
